/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      const crossSellElements = this.querySelectorAll('cc-cart-cross-sell');
      if (crossSellElements && crossSellElements.length > 0) {
        crossSellElements.forEach((el) => {
          if (el && typeof el.init === 'function') {
            el.init();
          }
        });
      }
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      const crossSellElements = this.querySelectorAll('cc-cart-cross-sell');
      if (crossSellElements && crossSellElements.length > 0) {
        crossSellElements.forEach((el) => {
          if (el && typeof el.init === 'function') {
            el.init();
          }
        });
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    const cartForm = this.querySelector('cart-form');
    if (!cartForm) {
      console.error('cart-form element not found in cart-drawer');
      return;
    }

    if (typeof cartForm.refresh === 'function') {
      cartForm.refresh();
    } else {
      console.error('cart-form.refresh is not a function');
    }
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    const cartForm = this.querySelector('cart-form');
    if (!cartForm) {
      console.error('cart-form element not found in cart-drawer');
      return;
    }

    if (!html || html.trim() === '') {
      console.error('updateFromCartChange: empty HTML provided');
      return;
    }

    if (typeof cartForm.refreshFromHtml === 'function') {
      cartForm.refreshFromHtml(html);
    } else {
      console.error('cart-form.refreshFromHtml is not a function');
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);
